import { analytics, FeaturePaywallEvents } from '@/lib/analytics'
import type { PlanType } from '@/lib/plans'

interface FeaturePaywallOpenedEventData {
  feature: string
  minimumPlan: PlanType | null
  currentPlan: string
  userRole: 'Administrator' | 'User'
  isManaged: boolean
  source: string | null
}

interface FeaturePaywallClosedEventData {
  feature: string
  minimumPlan: PlanType | null
  currentPlan: string
  converted: boolean
  durationMs: number
}

interface FeaturePaywallConvertedEventData {
  feature: string
  minimumPlan: PlanType | null
  currentPlan: string
  userRole: 'Administrator' | 'User'
}

interface FeaturePaywallBlockedEventData {
  feature: string
  minimumPlan: PlanType | null
  currentPlan: string
  source: string | null
}

interface FeaturePaywallBadgeClickedEventData {
  feature: string
  minimumPlan: PlanType | null
  currentPlan: string
}

interface FeaturePaywallBadgeViewedEventData {
  feature: string
  minimumPlan: PlanType | null
  currentPlan: string
}

export function trackFeaturePaywallOpened(
  data: FeaturePaywallOpenedEventData,
): void {
  analytics.track(FeaturePaywallEvents.OPENED, {
    feature: data.feature,
    minimum_plan: data.minimumPlan,
    current_plan: data.currentPlan,
    user_role: data.userRole,
    is_managed: data.isManaged,
    source: data.source,
  })
}

export function trackFeaturePaywallClosed(
  data: FeaturePaywallClosedEventData,
): void {
  analytics.track(FeaturePaywallEvents.CLOSED, {
    feature: data.feature,
    minimum_plan: data.minimumPlan,
    current_plan: data.currentPlan,
    converted: data.converted,
    duration_ms: data.durationMs,
  })
}

export function trackFeaturePaywallConverted(
  data: FeaturePaywallConvertedEventData,
): void {
  analytics.track(FeaturePaywallEvents.CONVERTED, {
    feature: data.feature,
    minimum_plan: data.minimumPlan,
    current_plan: data.currentPlan,
    user_role: data.userRole,
  })
}

export function trackFeaturePaywallBlocked(
  data: FeaturePaywallBlockedEventData,
): void {
  analytics.track(FeaturePaywallEvents.BLOCKED, {
    feature: data.feature,
    minimum_plan: data.minimumPlan,
    current_plan: data.currentPlan,
    source: data.source,
  })
}

export function trackFeaturePaywallBadgeClicked(
  data: FeaturePaywallBadgeClickedEventData,
): void {
  analytics.track(FeaturePaywallEvents.BADGE_CLICKED, {
    feature: data.feature,
    minimum_plan: data.minimumPlan,
    current_plan: data.currentPlan,
  })
}

export function trackFeaturePaywallBadgeViewed(
  data: FeaturePaywallBadgeViewedEventData,
): void {
  analytics.track(FeaturePaywallEvents.BADGE_VIEWED, {
    feature: data.feature,
    minimum_plan: data.minimumPlan,
    current_plan: data.currentPlan,
  })
}
